import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import gql from 'graphql-tag';
import FacilitiesLegendItem, { DISPLAY_OPTIONS, DISPLAY_OPTION_SIMPLE, DISPLAY_OPTION_PIN } from '../FacilitiesLegendItem';
import styles from './styles.scss';

export const ITEM_DISPLAY_OPTION_SIMPLE = DISPLAY_OPTION_SIMPLE;
export const ITEM_DISPLAY_OPTION_PIN = DISPLAY_OPTION_PIN;

const propTypes = {
  className: PropTypes.string,
  itemDisableLink: PropTypes.bool,
  itemDisplayOption: PropTypes.oneOf(DISPLAY_OPTIONS),
  facilities: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
  ).isRequired,
  onItemHover: PropTypes.func,
  primaryFacilityId: PropTypes.string,
  showPrimaryFacility: PropTypes.bool,
};

const defaultProps = {
  className: undefined,
  itemDisableLink: undefined,
  itemDisplayOption: undefined,
  onItemHover: undefined,
  primaryFacilityId: undefined,
  showPrimaryFacility: true,
};

const FacilitiesLegend = ({
  className,
  facilities,
  itemDisableLink,
  itemDisplayOption,
  onItemHover,
  primaryFacilityId,
  showPrimaryFacility,
}) => {
  const primaryFacility = primaryFacilityId
    && facilities.find(facility => facility.id === primaryFacilityId);

  const secondaryFacilities = primaryFacilityId
    ? facilities.filter(facility => facility.id !== primaryFacilityId)
    : facilities;

  const classes = cx(
    styles.list,
    className,
  );

  return (
    <ul className={classes}>
      {showPrimaryFacility && primaryFacility && (
        <FacilitiesLegendItem
          disableLink={itemDisableLink}
          displayOption={itemDisplayOption}
          facility={primaryFacility}
          onHover={onItemHover}
          primary
        />
      )}
      {secondaryFacilities.map((facility, index) => (
        <FacilitiesLegendItem
          key={facility.id}
          disableLink={itemDisableLink}
          displayOption={itemDisplayOption}
          index={index}
          onHover={onItemHover}
          facility={facility}
        />
      ))}
    </ul>
  );
};

FacilitiesLegend.propTypes = propTypes;
FacilitiesLegend.defaultProps = defaultProps;

FacilitiesLegend.fragments = {
  facility: gql`
    fragment FacilitiesLegendFacility on Facility {
      id
      ...FacilitiesLegendItemFacility
    }

    ${FacilitiesLegendItem.fragments.facility}
  `,
};

export default FacilitiesLegend;
